/**
 * 🟥 CUADRO NEGRO API Insights v4 (feb-2026) — hook Transformer.
 */
import { useEffect, useState } from "react";
import { fetchInsightsV4 } from "../services/insightsV4Service";

export function useInsightsV4(userId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const d = await fetchInsightsV4(userId);
      setData(d);
      setLoading(false);
    }
    load();
  }, [userId]);

  return { data, loading };
}
